import { gql } from '@apollo/client';

export const  GET_DQ_REPORTS = gql`
    query getDataQualityReports($studyRef: ObjectId!) {
        dataQualityReports(studyId: $studyRef)
    }
`;
